var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpBoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 9.16347L16.0438 9.23633L16.1471 9.23633L18 9.23633L18.6043 9.23633L18.1766 8.8094L10.1766 0.822769L10 0.646436L9.82337 0.822769L1.82337 8.8094L1.39573 9.23632L2 9.23632L3.5 9.23632L3.59919 9.23632L3.6714 9.16832L9.99515 3.21257L15.9707 9.16347Z",
    fill: "#4F4F4F",
    stroke: "#4F4F4F",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBoldIcon);
export default __webpack_public_path__ + "static/media/arrow-up-bold-icon.132df9e7348f0476d2013348aa1a6f56.svg";
export { ForwardRef as ReactComponent };